import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color", "className", "textAligned"];
import classNames from 'classnames';
import styles from './icon.module.css';

var useIconSize = function useIconSize(size) {
  switch (size) {
    case 'small':
      // 16px
      return '1rem';

    case 'medium':
      // 24px
      return '1.5rem';

    case 'large':
      // 32px
      return '2rem';

    case 'x-large':
      // 56px
      return '3.5rem';

    default:
      return size;
  }
};

var useIconProps = function useIconProps(_ref) {
  var _classNames;

  var size = _ref.size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      className = _ref.className,
      textAligned = _ref.textAligned,
      props = _objectWithoutProperties(_ref, _excluded);

  var resolvedSize = useIconSize(size);
  return _objectSpread({
    'aria-hidden': 'true',
    className: classNames(className, (_classNames = {}, _defineProperty(_classNames, styles.sized, size === undefined), _defineProperty(_classNames, styles.textAligned, textAligned), _classNames)),
    fill: color,
    focusable: 'false',
    width: resolvedSize,
    height: resolvedSize
  }, props);
};

export { useIconProps };